<template>
  <div
    class="el-text--align-center px-24 pt-24"
  >
    <el-icon
      class="my-16"
      name="i-check-circle-o--16"
      color="brand-primary"
      size="72"
    />
    <div class="el-text el-text--display-regular mb-8">
      {{ $t("delete-account.request-confirmation-step.title") }}
    </div>
    <div class="el-text el-text--body-24 px-24">
      <span>{{ $t("delete-account.request-confirmation-step.message") }}</span>
    </div>
    <el-button
      class="mt-16"
      @click="handleDoneButtonClick"
    >
      {{ $t("action.done") }}
    </el-button>
  </div>
</template>

<script>

export default {
  name: 'RequestConfirmationStep',
  emits: ['done-click'],
  methods: {
    handleDoneButtonClick() {
      this.$emit('done-click');
    }
  }
};
</script>
